/**
 * Remplace les placeholders dans un path template avec des valeurs réelles
 * @param pathTemplate - Le template avec des placeholders (ex: "/brokers/:id/analysis")
 * @param params - Les paramètres à remplacer (ex: { id: "123" })
 * @returns Le path avec les paramètres remplacés
 */
export const replacePlaceholders = (
	pathTemplate: string,
	params: Record<string, string | number>,
): string => {
	let result = pathTemplate;

	for (const [key, value] of Object.entries(params)) {
		result = result.replace(`:${key}`, String(value));
	}

	return result;
};

/**
 * Extrait les placeholders d'un path template
 * @param pathTemplate - Le template (ex: "/brokers/:id/analysis/:type")
 * @returns Array des placeholders (ex: ["id", "type"])
 */
export const extractPlaceholders = (pathTemplate: string): string[] => {
	const matches = pathTemplate.match(/:([a-zA-Z_][a-zA-Z0-9_]*)/g);
	return matches ? matches.map((match) => match.slice(1)) : [];
};
